var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPancakes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#F29014;}\n\t.st2{fill:#F8AA36;}\n\t.st3{fill:#FFD881;}\n\t.st4{fill:#D27910;}\n\t.st5{clip-path:url(#SVGID_2_);fill:#D27910;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.63,184.66c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.34,150.37,62.94,184.66,105.63,184.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.85,122.2c0,13.87-20.24,25.12-45.22,25.12s-45.22-11.25-45.22-25.12s20.24-25.12,45.22-25.12 S150.85,108.33,150.85,122.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.85,115.25c0,13.87-20.24,25.12-45.22,25.12s-45.22-11.25-45.22-25.12s20.24-25.12,45.22-25.12 S150.85,101.38,150.85,115.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.85,108.29c0,13.87-20.24,25.12-45.22,25.12s-45.22-11.25-45.22-25.12s20.24-25.12,45.22-25.12 S150.85,94.42,150.85,108.29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.85,101.33c0,13.87-20.24,25.12-45.22,25.12s-45.22-11.25-45.22-25.12s20.24-25.12,45.22-25.12 S150.85,87.46,150.85,101.33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.85,94.38c0,13.87-20.24,25.12-45.22,25.12s-45.22-11.25-45.22-25.12s20.24-25.12,45.22-25.12 S150.85,80.51,150.85,94.38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.85,90.09c0,0.03-0.02,0.06-0.06,0.06l0,0h-0.11c-0.03,0-0.05-0.03-0.05-0.06c0-0.04,0.02-0.06,0.05-0.06 h0.11C100.83,90.03,100.85,90.05,100.85,90.09"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.05,76.88c-12.83-3.91-18.23-1.94-17.39,8.15c0.22,2.61-3.37,6.95-6.96,9.46 c-8.34,5.81-4.76,15.53,9.57,8.37c7.17-3.58,17.63-3.34,30.33,0.54c10.65,3.26,17.24,7.21,18.11,11.99 c4.23-1.38,6.56-2.68,8.63-4.42c-0.88-1.98-4.79-7.68-10.98-10.4c-11.72-5.14-0.4-12.54,8.37-14.34c7.94-1.64,0.11-7.61-11.95-7.4 C112.7,79.05,115.73,82.58,97.05,76.88"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "130.74,110.57 139.33,110.57 139.33,138.74 130.74,138.74 130.74,110.57  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.74,115.25c0,9.89,0.22,15.89,0.22,19.35c0,6.74,8.26,5.54,8.26-5.65c0-11.2,0.1-18.37,0.1-18.37 L130.74,115.25L130.74,115.25z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.93,82.54c1.36,0.78,1.36,5.51,0,6.28l-9.84,5.61c-1.36,0.77-3.56,0.77-4.92,0l-9.84-5.61 c-1.36-0.77-1.36-5.5,0-6.28l9.84-2.13c1.36-0.78,3.55-0.78,4.91,0L117.93,82.54z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.93,82.54c1.36,0.78,1.36,2.03,0,2.8l-9.84,5.61c-1.36,0.77-3.56,0.77-4.92,0l-9.84-5.61 c-1.36-0.77-1.36-2.03,0-2.8l9.84-5.61c1.36-0.77,3.55-0.77,4.91,0L117.93,82.54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancakes);
export default __webpack_public_path__ + "static/media/Pancakes.c389282b94b61e4bfa04bd16a8ec6e59.svg";
export { ForwardRef as ReactComponent };